import { SubmitPromocodePasswordFormService } from 'types/services';
import { m8API } from '../m8';

export const submitPromocodePasswordForm: SubmitPromocodePasswordFormService = async (
  params
) => {
  const users = await m8API.admin.getPromoUsers();

  const user = users[0];

  await m8API.admin.setUserPassword({
    idUser: user.id,
    newPassword: params.password,
  });
};
